import { List } from '@mui/material';
import moment from 'moment';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { InfoListItem } from '~/components/MyWorkspace/InfoListItem';
import { AbsenceEntry, AbsenceType } from '~/data/absences/types';

export interface AbsenceInfoProps {
  listItem: AbsenceEntry;
}

export const AbsenceInfo: React.FC<AbsenceInfoProps> = ({ listItem }) => {
  const { t } = useTranslation();

  return (
    <List disablePadding={true}>
      <InfoListItem
        primaryText={t('startDate')}
        secondaryText={moment(listItem.startDate).format('L')}
        dataCy="start-date"
      />
      {listItem.endDate && (
        <InfoListItem
          primaryText={t('endDate')}
          secondaryText={moment(listItem.endDate).format('L')}
          dataCy="end-date"
        />
      )}
      <InfoListItem
        primaryText={t('type')}
        secondaryText={t(`type${listItem.type}`)}
        dataCy="type"
      />
      {listItem.type === AbsenceType.SHORT && listItem.days && (
        <InfoListItem
          primaryText={t('days')}
          secondaryText={listItem.days.toString()}
          dataCy="days"
        />
      )}
      {/*To add this field when we have BE, so it would be clear how to download on click.*/}
      {/*<InfoListItem*/}
      {/*  primaryText={t('attachment')}*/}
      {/*  secondaryText={listItem.attachment}*/}
      {/*/>*/}
      <InfoListItem
        primaryText={t('status')}
        secondaryText={listItem.status}
        dataCy="status"
      />
    </List>
  );
};
